import React from "react";
import PropTypes from "prop-types";
import NotificationSettingsItem from "../NotificationSettingsItem";
import styles from "./NotificationSettingsList.module.css"
// NotificationSettingsList.jsx

export function NotificationSettingsList({ items, header, view }) {
  return (
    <div className={styles.container}>
      <div className={styles.borderContainer}>
        <div className={styles.border}></div>
      </div>
      <h3 className={styles.header}>{header}</h3>
      <div className={styles.content}>
        {items.map((item, index) => (
          <NotificationSettingsItem
            key={index}
            label={item.label}
            on={item.on}
            view={view}
          />
        ))}
      </div>
    </div>
  );
}

NotificationSettingsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      on: PropTypes.bool.isRequired,
    })
  ).isRequired,
  header: PropTypes.string.isRequired,
  view: PropTypes.string, 
};

